function Hero() {
  return (
    <section id="hero" className="hero-section-split">
      <div className="hero-content-split">
        <div className="hero-text">
          <h1>Abadikan Setiap Momen, Rayakan Setiap Cerita</h1>
          <p>MomenQ hadir untuk membuat setiap momen spesialmu tak terlupakan. Mulai dari Virtual Photobooth hingga layanan digital lainnya yang akan datang.</p>
          <a
            href="https://wa.me/62859106695506?text=Halo, Saya mau cobain Demo MomenQ Virtual Photobooth"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Coba Demo Sekarang
          </a>
        </div>
        <div className="hero-image">
          <img src="/photobooth.png" alt="Virtual Photobooth" />
        </div>
      </div>
    </section>
  );
}

export default Hero;
